import silverMemberBanner from '@assets/common/silver_member_banner.webp';
import goldMemberBanner from '@assets/common/gold_member_banner.webp';
import diamondMemberBanner from '@assets/common/diamond_member_banner.webp';
import blackMemberBanner from '@assets/common/black_member_banner.webp';
export const messages = {
  Silver: [
    '合格おめでとうございます！',
    'より希望に沿った方とマッチされやすくなります。'
  ],
  Gold: [
    'デートで高評価を得られたので、上位40%のゴールドメンバーに特別合格となりました！'
  ],
  Diamond: [
    'デートで高評価を得られたので、上位20%のダイヤモンドメンバーに特別合格となりました！'
  ],
  Black: [
    'デートで高評価を得られたので、上位3%のブラックメンバーに特別合格となりました！'
  ]
};

export const popupBanner = {
  Silver: silverMemberBanner,
  Gold: goldMemberBanner,
  Diamond: diamondMemberBanner,
  Black: blackMemberBanner
};
